// extracted by mini-css-extract-plugin
export var container = "Testimonial-module--container--650d0";
export var isPrimary = "Testimonial-module--isPrimary--e311e";
export var isWhiteOut = "Testimonial-module--isWhiteOut--33501";
export var quoteMarkEnd = "Testimonial-module--quoteMarkEnd--54307";
export var quoteMarkStart = "Testimonial-module--quoteMarkStart--d6040";